(() => {
  const initialize = (root) => {
    root.querySelectorAll('[data-editorial-navigation]').forEach((reading) => {
      const navigation = reading.querySelector('[data-editorial-toc]');
      const list = navigation?.querySelector('ul');
      const body = reading.querySelector('[data-editorial-body]');
      if (!navigation || !list || !body) return;
      const headings = [...body.querySelectorAll('h2')].filter((heading) => heading.textContent.trim());
      list.replaceChildren();
      headings.forEach((heading, index) => {
        if (!heading.id) heading.id = `${reading.id}-chapter-${index + 1}`;
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent.trim();
        item.append(link);
        list.append(item);
      });
      navigation.hidden = headings.length < 2;
      reading.classList.toggle('nw-editorial__reading--with-toc', headings.length >= 2);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  else initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
